import React, { useState } from 'react';
import ProgressBar from '../../common/ProgressBar';


interface SkillExperienceProps {
    theme?: 'primary' | 'secondary',
    skill: string,
    experience: number,
    experienceLabel: string,
}

const SkillExperience: React.FC<SkillExperienceProps> = ({ theme = 'primary', skill, experience, experienceLabel }) => {

    return (
        <div className='grid grid-cols-2 w-full'>
            <p className=''>{skill}</p>
            <div className='flex flex-row items-center space-x-2 w-full'>
                

                    <ProgressBar
                        theme={theme}
                        size='xs'
                        actualValue={experience}
                        highestValue={5}
                        lowestValue={0}
                    />
                
                {/* min-w is necessary to be able to align multiple skill experiences */}
                <p className='min-w-20'>{experienceLabel}</p>
            </div>
        </div>
    );
};



export default SkillExperience;
